import { useEffect, useState } from 'react';
import { API_URL } from '../api';

const EVENT = 'planium:employee-avatar';
// Only an authenticated upload by the open account writes this small cache.
const updated = new Map();
const MAX_PREVIOUS_URLS = 64;
export function avatarSrc(personOrUrl) {
  const value = typeof personOrUrl === 'string' ? personOrUrl : personOrUrl?.avatar_url;
  if (!value || typeof value !== 'string') return undefined;
  try {
    const url = new URL(value, API_URL.replace(/\/$/, '') + '/');
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return undefined;
    return url.href;
  } catch (_) { return undefined; }
}
export function avatarChanged(employeeId, value, previous) {
  const id = String(employeeId || '');
  if (!id) return;
  const existing = updated.get(id);
  const obsolete = new Set(existing?.obsolete || []);
  obsolete.add(avatarSrc(previous) || null);
  if (existing) obsolete.add(existing.value);
  // Retain several replacements: old message objects may still contain v1
  // when the profile has already moved from v2 to v3. Bound memory per person.
  while (obsolete.size > MAX_PREVIOUS_URLS) {
    const oldest = [...obsolete].find(url => url !== null);
    obsolete.delete(oldest);
  }
  updated.set(id, { value: avatarSrc(value) || null, obsolete });
  if (updated.size > 100) updated.delete(updated.keys().next().value);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { employeeId: id } }));
}
export function useEmployeeAvatar(person, explicit) {
  const id = person?.kind === 'client' ? '' : String(person?.id || '');
  const [, render] = useState(0);
  useEffect(() => {
    const update = e => { if (id && e.detail?.employeeId === id) render(v => v + 1); };
    window.addEventListener(EVENT, update);
    return () => window.removeEventListener(EVENT, update);
  }, [id]);
  const incoming = avatarSrc(explicit || person);
  const local = id ? updated.get(id) : null;
  // All retained obsolete message URLs follow the latest local photo. A new
  // URL from a later HTTP payload remains authoritative over the local cache.
  return local?.obsolete.has(incoming || null) ? local.value || undefined : incoming;
}
export function chatAvatarPerson(chat, employeeId) {
  if (!(chat?.type_chat === 'direct' || chat?.is_dm === true)) return null;
  return (chat?.participants || []).find(person => !person.is_me &&
    !(person.kind !== 'client' && employeeId != null && String(person.id) === String(employeeId))) || null;
}
